import { autoRegisterFeature } from '@store/features/factory';

import { billingFeature } from './store/feature';

// Auto-register the billing feature
autoRegisterFeature(billingFeature);

// Export everything
export * from './components';
export * from './store';
export * from './types';

// Hooks
export { useEligibilityAccess } from './hooks/useEligibilityAccess';
export { useJotBillAccess } from './hooks/useJotBillAccess';
